import { createElement, forwardRef } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';

import useModals from 'Hooks/useModals';

export default function withModals(Component) {
  const displayName = `withModals(${ (Component.displayName || Component.name || 'Component') })`;

  const WithModals = forwardRef((props, ref) => {
    const modalsContext = useModals();
    return createElement(Component, {
      modalsContext,
      ref,
      ...props
    });
  });

  WithModals.displayName = displayName;
  WithModals.WrappedComponent = Component;

  return hoistNonReactStatics(WithModals, Component);
}
